export default __webpack_public_path__ + "static/media/Eric.1e8d7e2e.jpg";